import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { UiPopover } from 'ui-components';

export const StyledExpireAtRangeFilter = styled('div')(
  ({ theme }) => css`
    .range-picker-trigger {
      cursor: pointer;
      height: 46px;
      min-width: 280px;
      background: ${theme.palette.common.white};
      border: 1px solid ${theme.palette.gray.light};
      box-sizing: border-box;
      border-radius: 6px;
      padding: 12px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;

      .trigger-label {
        flex: 1;
        direction: rtl;
        text-align: right;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: ${theme.palette.gray.darkest};
        font-size: ${theme.typography.body.fontSize};

        &.placeholder {
          color: ${theme.palette.secondary.moreLight};
        }

        .date {
          color: ${theme.palette.gray.darkest};
          margin-left: 10px;
        }

        .time {
          color: ${theme.palette.secondary.moreLight};
          margin: 0 5px;
        }
      }
    }
  `
);

export const StyledExpireAtRangePopover = styled(UiPopover)(
  ({ theme }) => css`
    .MuiPaper-root {
      border: 1px solid ${theme.palette.gray.lighter};
      border-radius: 8px;
      box-shadow: 0px 8px 16px 0px rgba(145, 158, 171, 0.16);
      overflow: hidden;
      width: 480px;
    }

    .expire-at-range-content {
      display: flex;
      flex-direction: column;
      align-items: stretch;
    }

    .expire-at-range-options {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      padding: 12px;
      direction: rtl;
    }

    .expire-at-range-option {
      flex: 1 0 calc(33.333% - 6px);
      min-width: 0 !important;
      max-width: calc(33.333% - 6px);
      padding: 8px 12px !important;
      border-radius: 4px;
      font-size: ${theme.typography.captionLight.fontSize};
      line-height: ${theme.typography.captionLight.lineHeight};
      text-align: center;
      text-transform: none;

      &.MuiButton-outlinedDefault {
        border: 1px solid ${theme.palette.gray.lighter};
        color: ${theme.palette.gray.darker};

        &:hover {
          background-color: rgba(34, 34, 34, 0.04);
        }
      }

      &.MuiButton-outlinedPrimary {
        border: 1px solid ${theme.palette.primary.main};
        color: ${theme.palette.primary.light};
      }
    }

    .expire-at-range-footer {
      display: flex;
      align-items: center;
      justify-content: right;
      gap: 16px;
      padding: 16px 12px;
      background: ${theme.palette.secondary.lightest};
      direction: rtl;
      font-size: ${theme.typography.captionLight.fontSize};
      line-height: ${theme.typography.captionLight.lineHeight};
      color: ${theme.palette.text.primary};
      white-space: nowrap;
    }
  `
);
